// src/hooks/useNotifications.js
// Hook đọc notification_logs realtime từ Firestore

import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
  writeBatch,
  doc,
} from "firebase/firestore";
import { db } from "../lib/firebase";
import { useAuth } from "../contexts/AuthContext";

export function useNotifications() {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;

    const q = query(
      collection(db, "notification_logs"),
      where("userId", "==", user.uid),
      orderBy("sentAt", "desc"),
      limit(30)
    );

    const unsub = onSnapshot(q, (snap) => {
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });

    return unsub;
  }, [user]);

  // Đánh dấu tất cả là đã đọc
  const markAllRead = async () => {
    const unread = notifications.filter((n) => !n.isRead);
    if (!unread.length) return;

    const batch = writeBatch(db);
    unread.forEach((n) => {
      batch.update(doc(db, "notification_logs", n.id), { isRead: true });
    });
    await batch.commit();
  };

  // Đánh dấu 1 thông báo đã đọc
  const markRead = async (notifId) => {
    await writeBatch(db)
      .update(doc(db, "notification_logs", notifId), { isRead: true })
      .commit();
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  return { notifications, loading, unreadCount, markAllRead, markRead };
}
